import cn from 'clsx'
import { Text, type TextProps, type TextSize } from '@/components/Text/Text'
import type { Themes } from '@/Theme'

import css from './Heading.module.css'

interface HeadingProps extends Omit<TextProps, 'tag'> {
    tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5'
    theme?: Themes
}

export function Heading({ tag = 'h2', children, className, theme, ...rest }: HeadingProps) {
    const sizes: { [key: string]: TextSize } = {
        h1: theme === 'twist' ? 'major-base' : 'major-lg',
        h2: theme === 'twist' ? 'major-sm' : 'major-base',
        h3: theme === 'twist' ? 'minor-lg' : 'major-sm',
        h4: theme === 'twist' ? 'minor-base' : 'minor-lg',
        h5: theme === 'twist' ? 'minor-sm' : 'minor-base',
    } as const

    return (
        <Text
            className={cn(css.heading, css[tag], className)}
            tag={tag}
            size={sizes[tag as keyof typeof sizes]}
            {...rest}
        >
            {children}
        </Text>
    )
}
